'use strict';

angular.module('cloudBillingLegacyFrontend').directive('cbTenantManagement', function () {
  return {
    templateUrl: 'views/directive_cb_tenant_management.html',
    restrict: 'C',
    controller: 'CbTenantManagementCtrl',
    scope: {
      authenticationToken: '=',
      tenantId: '='
    }
  };
}).controller('CbTenantManagementCtrl', function($scope, $eaBackend, $controller, $modal, $q, $eaConfig, $location,$eaUserProfile, rfc4122, $eaReportData, $rootScope) {
  var self = this;

  $.extend(self, $controller('TeamEditUsersCtrlMixin', {$scope: $scope, $modal: $modal }));
  $.extend(self, $controller('TeamEditAppCtrlMixin', {$scope: $scope, $modal: $modal }));
  $.extend(self, $controller('TeamEditPermissionsCtrlMixin', {$scope: $scope, $modal: $modal }));
  $.extend(self, $controller('TeamsChooseContractMixinCtrl', {$scope: $scope, $modal: $modal, $controller: $controller, $eaUserProfile: $eaUserProfile }));
  $.extend(self, $controller('TenantSettingsCtrlMixin', {$scope: $scope, $modal: $modal, DataToken: $scope.authenticationToken, $eaBackend: $eaBackend, TenantId: $scope.tenantId }));
  $.extend(self, $controller('TeamManagementCtrlMixin', {$scope: $scope, $eaBackend: $eaBackend, $q: $q }));  
  $.extend(self, $controller('NotificationSettingsCtrlMixin', {$scope: $scope, $modal: $modal }));
  $.extend(self, $controller('ModalSingleLineBoxCtrlMixin', {$scope: $scope, $modal: $modal }));

  $scope.sessionLoaded  = false;
  $scope.teamProfile    = undefined;  
  $scope.teamAADConnection = undefined;
  $scope.availableRoles = [ { display: 'Member', value: 'member' }, { display: 'Administrator', value: 'admin' }];
  $scope.bucketsEnabled = $eaConfig.getConfiguration().features.buckets;
 
  $scope.loading = true;
  $scope.loadingMessage = undefined;

  // generate the callback uri
  var splittedUrl = $location.absUrl().split('/');
  var callbackUri = splittedUrl[0] + '//' + splittedUrl[2] + '/app/teams/invitation/accept';

  $scope.closePanel = function() {
    $rootScope.visibleUserManagement = false;
  };

  $scope.getDisplayName = function(user) {
    var userName;
    if (user.FirstName) { userName = user.FirstName + ' '; } else { userName = ''; }
    if (user.LastName) { userName = userName + user.LastName; }
    if (!userName) { userName = user.Contact; }

    return userName;
  };

  // allows to add a user
  $scope.addUser = function() {

      var existingUsers = $scope.teamProfile.Members.filter(function(user) {
        return user.Type !== 'app-only';
      });

      $scope.openTeamEditUserDialog(existingUsers, $scope.teamProfile.CloudSolutionProvider).then(function(result) {

          // wait for operations
          var operationPromisses= [];

          // removing all removed users
          result.removedUsers.forEach(function(user) {
            operationPromisses.push($scope.deleteUserFromTeam($scope.tenantId, user, $scope.authenticationToken));
          });

          // inviting all other users
          result.newUsers.forEach(function(user) {

            if ($scope.hasUserRole(user, 'notification'))
            {
              operationPromisses.push($eaBackend.dataRegisterUserToTeam($scope.tenantId, user.Contact, user.Role, user.Subscriptions, $scope.authenticationToken));
            } else {

              var fullAccess = false;

              if (user.Subscriptions && user.Subscriptions['*']) {
                fullAccess = true;
              }

              operationPromisses.push($eaBackend.dataInviteUserToTeamV2($scope.tenantId, user.Contact, user.Role, fullAccess, callbackUri, $scope.authenticationToken));
            }
          });

          // send out
          $scope.loading = true;
          $scope.loadingMessage = 'Adding Users...';
          $q.all(operationPromisses).finally(function() {

            $scope.loading = false;
            $scope.loadingMessage = 'Adding Users...';
            return $scope.reloadData();
          });
      });
  };

  $scope.editPermissions = function(user) {

    // load all contracts for this team
    $scope.loading = true;
    $scope.loadingMessage = 'Loading available subscriptions...';    
    $eaBackend.helperGetAvailableSubscriptions($scope.tenantId, $scope.authenticationToken).then(function(availableSubscriptions) {

        $scope.loading = false;
        $scope.loadingMessage = undefined;

        $scope.openTeamEditPermissionsDialog(user, availableSubscriptions).then(function (result) {

          $scope.loading = true;
          $scope.loadingMessage = 'Updating user...';    
          $eaBackend.dataUpdateTeamMembership($scope.tenantId, user.UserId, user.Role, result, undefined, $scope.authenticationToken).finally(function() {            
            return $scope.reloadData();
          });
        });
    });
  };

  $scope.editNotifications = function(user) {

    // ensure we have a fresh profile
    $scope.loading = true;
    return $eaUserProfile.load($scope.authenticationToken, true).then(function(profile) {

      // show the select contract dialog
      $scope.loading = false;
      return $scope.openContractChooser(profile, {team: $scope.teamProfile.Id}).then(function(selectedContract) {

        // load some contract information
        $scope.loading = true;
        return $eaReportData.loadContractDetails($scope.teamProfile.Id, selectedContract.Enrollment, $scope.authenticationToken).then(function(loadedContractInformation) {

          // load the notification settings for the selected contract and user
          return $eaBackend.dataGetContractNotifcationSettingsForUser($scope.teamProfile.Id, selectedContract.Enrollment, user.UserId, $scope.authenticationToken).then(function (loadedNotificationSettings) {

            // open the select permissions dialog
            $scope.loading = false;
            $scope.teamProfile.AccountPlan = 'enterprise';
            return $scope.openNotificationSettingsDialog(loadedContractInformation, loadedNotificationSettings, $scope.teamProfile, 'member').then(function (updatedData) {

              // store everything
              $scope.loading = true;
              $scope.loadingMessage = 'Updating user...';
              return $eaBackend.updateGetContractNotifcationSettingsForUser($scope.teamProfile.Id, selectedContract.Enrollment, user.UserId, updatedData.notificationInformation, $scope.authenticationToken).then(function() {
                $scope.loading = false;
                $scope.loadingMessage = undefined;
              });
            });
          });
        });
      });
    });

  };

  $scope.addApp = function() {
    var newApp = { Name: '', ClientId: rfc4122.v4(), ClientSecret: rfc4122.v4(), Role: 'member', WildCardSubscriptions: true };
    $scope.openTeamEditAppDialog(newApp).then(function(appModel) {
      var subscriptions = appModel.WildCardSubscriptions ? { '*': ['*'] } : {};
      return $eaBackend.dataRegisterAppToTeam($scope.tenantId, appModel.Name, appModel.ClientId, appModel.ClientSecret, appModel.Role, subscriptions, $scope.authenticationToken).finally(function() {
        return $scope.reloadData();
      });
    });
  };

  $scope.deleteUserFromTeamEx = function(user) {

      var deleteOk = confirm('Do you really want to remove user ' + $scope.getDisplayName(user) + ' from this team?');
      if (deleteOk) {
        $scope.loading = true;
        $scope.loadingMessage = 'Removing User...';
        $scope.deleteUserFromTeam($scope.tenantId, user, $scope.authenticationToken).then(function () {

          // just remove from the collection
          var idx = $scope.teamProfile.Members.indexOf(user);
          if (idx !== -1) {
              $scope.teamProfile.Members.splice(idx, 1);
          }

            $scope.loading = false;
            $scope.loadingMessage = undefined;
        });
      }
  };

  $scope.reloadData = function() {

      $scope.loading = true;
      $scope.loadingMessage = undefined;

      // load the user profile to get the information if the user is allowed to manage the team
      return $eaUserProfile.load($scope.authenticationToken, true).then(function(profile) {

        $scope.activeTeamBilling = $eaUserProfile.getTeam(profile, $scope.tenantId);

        return $eaBackend.dataGetTeamProfile($scope.tenantId, true, $scope.authenticationToken).then(function (teamProfile) {
      
          $scope.teamProfile = teamProfile;            

          return $eaBackend.dataGetAADConnections($scope.tenantId, $scope.authenticationToken).then(function (connections) {
            if (connections && connections.length > 0) {
              $scope.teamAADConnection = connections[0];
            } else {
              $scope.teamAADConnection = null;
            }

            $scope.loading = false;
          });       
        });
      });
  };
  
  $scope.updateTeamName = function(data) {
    return $eaBackend.dataUpdateTeamProfile($scope.tenantId, { Name: data }, $scope.authenticationToken).then(function() {
      return true;
    });
  };
    
  $scope.openSettings = function() {
    $scope.openTenantSettingsDialog().then(function() {
      return $scope.reloadData();
    });
  };

  $scope.changeUserRole = function(user) {

    // check if we need to reset teh users subscriptions
    if (user.Role === 'admin') {
      user.Subscriptions = {'*': ['*']};
    }

    $scope.loading = true;      
    $eaBackend.dataUpdateTeamMembership($scope.tenantId, user.UserId, user.Role, user.Subscriptions, undefined, $scope.authenticationToken).finally(function() {
      return $scope.reloadData();
    });
  };

  $scope.editContactAddress = function(user) {
    $scope.openSingleLineBox('Update User Settings', 'Please enter a new e-mail address to update the contact information of this user.', user.Contact).then(function(updatedContact) {
      $scope.loading = true;      
      $eaBackend.dataUpdateTeamMembership($scope.tenantId, user.UserId, undefined, undefined, updatedContact, $scope.authenticationToken).finally(function() {
        return $scope.reloadData();
      });
    });
  };

  $scope.getClientId = function(appProfile) {
    return appProfile.Contact.split('@')[0];
  };

  $scope.canRoleBeChanged = function(user) {
    return !$scope.isUserDelegationAdmin(user) && !$scope.isUserPseudoUser(user) && !$scope.isUserSelf(user) && (user.Role !== 'notification') && $scope.activeTeamBilling.AccountOwner !== user.UserId;
  };

  $scope.getUserHintText = function(user) {    
    if ($scope.activeTeamBilling.AccountOwner === user.UserId) {
      return 'The user ' + $scope.getDisplayName(user) + ' is the owner of the account and cannot be removed.';
    } else {
      return '';
    }
  };

  return $scope.reloadData().then(function() {
      $scope.sessionLoaded  = true;
  });
});

